module.exports = __webpack_public_path__ + "static/media/users_active.f92a2169.svg";